// src/components/shell/UserAvatar.js
// Avatar du compte : photo de profil FullMargin si /api/me en renvoie une,
// sinon le dégradé + initiales (rendu historique). Une image cassée retombe
// aussi sur les initiales.
import React, { useEffect, useState } from "react";

export default function UserAvatar({ photo, initials, size = 36, className = "" }) {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [photo]);

  const style = { height: size, width: size };

  if (photo && !broken) {
    return (
      <img
        src={photo}
        alt=""
        style={style}
        onError={() => setBroken(true)}
        className={`shrink-0 rounded-full object-cover ring-1 ring-black/10 dark:ring-white/15 ${className}`}
      />
    );
  }

  return (
    <span
      style={style}
      className={`grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-violet-500 to-fuchsia-500 font-bold text-white ${className}`}
    >
      {initials}
    </span>
  );
}
